import type { JSX } from 'react'

export const SearchHintIcon = (): JSX.Element => (
  <use href='#searchHintIcon' height='100%' width='100%' />
)
